import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.VITE_API_BASE_URL ||
  "http://localhost:59421";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
});

export const apiBaseUrl = API_BASE_URL.replace(/\/$/, "");

function getLoggedUrl(config = {}) {
  const baseUrl = String(config.baseURL || API_BASE_URL || "").replace(/\/$/, "");
  const requestUrl = String(config.url || "");

  if (/^https?:\/\//i.test(requestUrl)) {
    return requestUrl;
  }

  return `${baseUrl}${requestUrl.startsWith("/") ? requestUrl : `/${requestUrl}`}`;
}

apiClient.interceptors.request.use((config) => {
  console.log("API URL:", getLoggedUrl(config));
  return config;
});

apiClient.interceptors.response.use(
  (response) => {
    console.log("API response status:", response.status, getLoggedUrl(response.config));
    return response;
  },
  (error) => {
    console.log(
      "API response status:",
      error.response?.status || "no response",
      getLoggedUrl(error.config || {})
    );
    return Promise.reject(error);
  }
);

export function getApi(url, config) {
  return apiClient.get(url, config);
}

export function postApi(url, data, config) {
  return apiClient.post(url, data, config);
}

export function putApi(url, data, config) {
  return apiClient.put(url, data, config);
}

export function deleteApi(url, config) {
  return apiClient.delete(url, config);
}
